// Rotate prompt cho iPad/tablet ở portrait — landing design cho landscape,
// khi user mở trên iPad/tablet portrait sẽ thấy lệch → show .layer-rotate yêu cầu xoay.
// Theo pattern Yumo (cfl/landing/2026-yumo/assets/main/main.js) — chỉ khác condition:
// Yumo: phone portrait (innerWidth < 768). Đây: tablet portrait (innerWidth >= 768).
function isTabletDevice() {
  const ua = navigator.userAgent;
  const isiPad = /iPad/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  return isiPad || isAndroidTablet;
}

function checkRotateScreen() {
  if (
    isTabletDevice() &&
    window.innerWidth >= 768 &&                  // tablet size (loại trừ phone)
    window.innerWidth < window.innerHeight       // đang ở chế độ dọc (portrait)
  ) {
    $('.layer-rotate').show();
  } else {
    $('.layer-rotate').hide();
  }
}
$(function () {
  checkRotateScreen();
});
checkRotateScreen();
window.addEventListener('resize', checkRotateScreen);

// Section #nth-ld-frame2 (PC) có height fix 5800px + .content scale(0.8) + .posts absolute.
// Khi nhiều bài, posts tràn ngoài 5800px, libraryMainsite stop scroll → kẹt.
// Đo bottom của bài cuối (đã bao gồm scale) và set section height vừa khít,
// sau đó báo libraryMainsite remeasure qua resize event.
let _fittingFrame2 = false;
function fitFrame2() {
  if (_fittingFrame2) return; // chống loop với resize event
  const section = document.getElementById('nth-ld-frame2');
  if (!section) return;
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) return;
  const posts = section.querySelector('.posts');
  const lastPost = posts && posts.lastElementChild;
  if (!lastPost) return;
  _fittingFrame2 = true;
  const sectionRect = section.getBoundingClientRect();
  const lastRect = lastPost.getBoundingClientRect();
  const needed = lastRect.bottom - sectionRect.top + 80;
  section.style.height = Math.max(needed, 5800) + 'px';
  // Báo lib remeasure (lib dùng resize để tính lại virtual scroll/page height)
  window.dispatchEvent(new Event('resize'));
  // Mở khoá sau frame tiếp để resize event do mình bắn không re-trigger.
  requestAnimationFrame(() => { _fittingFrame2 = false; });
}

window.addEventListener('load', fitFrame2);
// Re-fit khi user resize thật (xoay device, đổi DPR, ...) hoặc khi ảnh post load xong
window.addEventListener('resize', fitFrame2);
window.addEventListener('load', function () {
  document.querySelectorAll('#nth-ld-frame2 img').forEach(function (img) {
    if (!img.complete) img.addEventListener('load', fitFrame2, { once: true });
  });
});
